
import './Preloader.css';
import React from 'react';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loader">
        <div className="loader-outter"></div>
        <div className="loader-inner"></div>
        <div className="indicator">
          {/* Example SVG indicator */}
          <svg width="80" height="80" viewBox="0 0 100 100">
            <polyline id="back" points="50,10 90,50 50,90 10,50" />
            <polyline id="front" points="50,10 90,50 50,90 10,50" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
